import React, { useEffect, useState } from 'react';
import { FaMousePointer } from 'react-icons/fa';
import { subscribeToEvent, unsubscribeFromEvent, useRecord } from '../../../services/deepstream';
import { useCurrentBoard } from '../../../services/state';

const Cursor = ({ userId }) => {
  const { id: boardId } = useCurrentBoard();
  const { email, color } = useRecord(`board/${boardId}/user/${userId}`);

  const [{ percentageX, percentageY, visible }, setMousePosition] = useState({
    percentageX: 0,
    percentageY: 0,
    visible: false
  });

  useEffect(() => {
    const mouseMoveEvent = `project/${boardId}/user/${userId}/mousemove`;

    const updateMousePosition = ({ percentageX, percentageY }) => {
      setMousePosition({ percentageX, percentageY, visible: true });
    };

    subscribeToEvent(mouseMoveEvent, updateMousePosition);

    return () => {
      unsubscribeFromEvent(mouseMoveEvent, updateMousePosition);
    };
  }, [userId, boardId]);

  return (
    <div
      className="cursor"
      style={{
        top: `${percentageY}%`,
        left: `${percentageX}%`,
        display: visible ? 'flex' : 'none',
        color: color
      }}
    >
      <FaMousePointer />
      <div className="cursor-user-email" style={{ backgroundColor: color, color: 'white' }}>
        {email}
      </div>
    </div>
  );
};

export default Cursor;
